export * from './program-carousel-item';
export * from './program-carousel-item-bottom';
export * from './program-details';

import { ProgramCarouselItemComponent } from './program-carousel-item';
import { ProgramCarouselItemBottomComponent } from './program-carousel-item-bottom';
import { ProgramDetailsComponent } from './program-details';




export const ProgramAtoms = [
    ProgramCarouselItemComponent,
    ProgramCarouselItemBottomComponent,
    ProgramDetailsComponent,
]